import axios, {
  type AxiosInstance,
  type AxiosResponse,
  type AxiosRequestConfig,
  type InternalAxiosRequestConfig
} from 'axios'
import { HttpXResponse } from './HttpXResponse'

interface HttpXRequestInterceptors {
  onFulFilled?: (
    config: InternalAxiosRequestConfig<any>
  ) => InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>
  onRejext?: (error: any) => any
}

interface HttpXResponseInterceptors {
  onFulfilled?:
    | ((
        value: AxiosResponse<any, any>
      ) => AxiosResponse<any, any> | Promise<AxiosResponse<any, any>>)
    | null
  onRejected?: ((error: any) => any) | null
}

export class HttpX {
  private _inst: AxiosInstance | undefined = undefined
  private _id: string = ''
  constructor(id: string, conf?: AxiosRequestConfig) {
    this._id = id
    this._inst = axios.create(conf)
  }

  /**
   * POST请求
   * @param path 
   * @param data 
   * @param config 
   * @returns 
   */
  public async post<T>(
    path: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<HttpXResponse<T>> {
    try {
      if(path.includes('?')){
        path+="&rand="+Date.now()
      }else{
        path+='?rand='+Date.now()
      }
      // console.log(path)
      const r = await this._inst?.post(path, data ?? {})
      return r?.data as HttpXResponse<T>
    } catch (error) {
      console.error(`[HttpX:${this._id}][POST:${path}]`, data, config, error)
      return error as HttpXResponse<T>
    }
  }

  /**
   * GET请求
   * @param path 
   * @param params 
   * @param config 
   * @returns 
   */
  public async get<T>(
    path: string,
    params?: any,
    config?: AxiosRequestConfig
  ): Promise<HttpXResponse<T>> {
    try {
      params = {...params??{},rand:Date.now()}
      if (params) {
        config = config ?? {}
        config.params = params
      }
      // console.log(path,params)
      const r = await this._inst?.get(path, config)
      return r?.data as HttpXResponse<T>
    } catch (error) {
      console.error(`[HttpX:${this._id}][GET:${path}]`, params, config, error)
      return error as HttpXResponse<T>
    }
  }
  
  public useRequestInterceptors(mid: HttpXRequestInterceptors) {
    this._inst?.interceptors.request.use(mid.onFulFilled, mid.onRejext)
  }

  public useResponseInterceptors(mid: HttpXResponseInterceptors) {
    this._inst?.interceptors.response.use(mid.onFulfilled, mid.onRejected)
  }
}

export type { HttpXRequestInterceptors, HttpXResponseInterceptors }
